import { render, staticRenderFns } from "./EditSupplier.vue?vue&type=template&id=5f161c74&"
import script from "./EditSupplier.vue?vue&type=script&lang=js&"
export * from "./EditSupplier.vue?vue&type=script&lang=js&"
import style0 from "./EditSupplier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports